/**
 * Created on 2025-08-11.
 * Copyright © 2025 Curriculum Ltd. All rights reserved.
 */
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'curr-privacy-policy-popup',
  templateUrl: './privacy-policy-popup.component.html',
  styleUrls: ['./privacy-policy-popup.component.scss']
})
export class PrivacyPolicyPopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PrivacyPolicyPopupComponent>
  ) { }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
